import { NonRetryableError } from "./nonRetryableError.ts";

export class ForbiddenError extends NonRetryableError {}
